import Vapi from 'vuex-rest-api';
import axios from '@/api/axios';
import { add } from '@/utils/utils';

const store = new Vapi({
  axios,
  state: {
    tenants: [],
    tenantId: null,
    currentTenant: null,
  },
})
  .post({
    action: 'createTenant',
    path: 'tenant',
    onSuccess: add('tenant'),
  })
  .get({
    action: 'getTenants',
    property: 'tenants',
    path: 'tenants',
    onSuccess: (s, { data }) => {
      s.tenants = data;
      s.currentTenant = s.tenants.find(x => x.id === s.tenantId) ?? null;
    },
  })
  .getStore();

store.actions.changeTenant = (ctx, tenantId) => {
  ctx.commit('setTenant', tenantId);
  ctx.commit('clearUsers');
  ctx.commit('clearRoles');
  ctx.commit('clearCompetences');
};

store.mutations.setTenant = (s, v) => {
  s.tenantId = v;
  s.currentTenant = s.tenants.find(x => x.id === v) ?? null;
};

store.getters = {
  tenantId: s => s.tenantId,
  showUserName: s => s.currentTenant?.showUserName ?? false,
  emailIsUserName: s => s.currentTenant?.emailIsUserName ?? true,
};

export default store;
